import { put, takeEvery, call } from 'redux-saga/effects';
import get from '../getApiCaller';

const API_DATA = (payload) => {
  return get(`places/categories?countryId=${payload}`, 'Get', true).then(
    (response) => {
      return response;
    }
  );
};

export const GET_CATEGORIES_LIST_SAGA = function* perform_loginAction() {
  yield takeEvery('GET_CATEGORIES_LIST', function* (action) {
    yield put({ type: 'GET_CATEGORIES_LIST_STARTED' });
    try {
      const DATA = yield call(API_DATA.bind(this, action.payload));
      yield put({
        type: 'GET_CATEGORIES_LIST_SUCCESS',
        payload: DATA,
      });
    } catch (error) {
      yield put({
        type: 'GET_CATEGORIES_LIST_FAILED',
        payload: error,
      });
    }
  });
};
